var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayoutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5371 27.9231V33.3077C24.5371 34.0217 24.2615 34.7066 23.7711 35.2114C23.2806 35.7162 22.6155 36 21.9218 36H3.61523C2.92162 36 2.25644 35.7162 1.76598 35.2114C1.27553 34.7066 1 34.0217 1 33.3077V3.69231C1 2.97825 1.27553 2.29347 1.76598 1.78856C2.25644 1.28365 2.92162 1 3.61523 1H21.9218C22.6155 1 23.2806 1.28365 23.7711 1.78856C24.2615 2.29347 24.5371 2.97825 24.5371 3.69231V9.07692",
    stroke: "black",
    strokeOpacity: 0.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6914 18.5H34.998",
    stroke: "black",
    strokeOpacity: 0.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7695 13.1152L35 18.4998L29.7695 23.8845",
    stroke: "black",
    strokeOpacity: 0.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayoutIcon);
export default __webpack_public_path__ + "static/media/PayoutIcon.0d25c7586474ab66e37a993e83bdad5c.svg";
export { ForwardRef as ReactComponent };